import styled from 'styled-components';

export const NumberSec = styled.span`
  font-weight: 700;
  color: var(--subTextColor);
  font-size: 13px;
  margin-right: 12px;
`;
